module.exports = __webpack_public_path__ + "fcb484e26ee8f882af02fa5230835bde.svg";